export var makeFlexWrap = function (props) {
    var flexWrap = props.flexWrap, flexWrapReverse = props.flexWrapReverse;
    return "".concat(flexWrap).concat(flexWrapReverse && flexWrap !== 'nowrap' ? '-reverse' : '');
};
